import { render, staticRenderFns } from "./ArticleMetadataEdit.vue?vue&type=template&id=36699db6"
import script from "./ArticleMetadataEdit.vue?vue&type=script&lang=js"
export * from "./ArticleMetadataEdit.vue?vue&type=script&lang=js"
import style0 from "./ArticleMetadataEdit.vue?vue&type=style&index=0&id=36699db6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports